import { NO_ROLE_FLAG } from '#components/patterns/entity-select/role/option-constants.ts';
import type { Host } from '#dn-types/host.ts';
import { getIpV4, getIpV6 } from '#util/hostIps.ts';
import { mapOverridesToForm } from './advanced/mappers/mapOverridesToForm.ts';
import type { HostFormData } from './host-form-schema.ts';
import { parsePublicIPOrHostname } from './parsePublicIPOrHostname.ts';

export function mapHostToForm(host: Host, roleName?: string) {
  return {
    name: host.name,
    networkID: host.networkID,
    ipv4Address: getIpV4(host) ?? '',
    ipv6Address: getIpV6(host) ?? '',
    ipv4Enabled: getIpV4(host) !== undefined,
    listenPort: host.listenPort,
    publicIPOrHostname: parsePublicIPOrHostname(host.staticAddresses?.[0]),
    roleName: roleName ?? '',
    roleID: host.roleID ?? NO_ROLE_FLAG,
    tags: host.tags,
    configOverrides: mapOverridesToForm(host.configOverrides),
  } satisfies HostFormData;
}
